import { render } from "./PodftAsideModel.vue?vue&type=template&id=176237cc&scoped=true"
import script from "./PodftAsideModel.vue?vue&type=script&lang=js"
export * from "./PodftAsideModel.vue?vue&type=script&lang=js"

import "./PodftAsideModel.vue?vue&type=style&index=0&id=176237cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176237cc"]])

export default __exports__